"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGates = setGates;
exports.handleSetGates = handleSetGates;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

function setGates(gates) {
  return {
    type: _ActionTypes.SET_GATES,
    payload: gates
  };
}

function handleSetGates(gates) {
  return function (dispatch) {
    return dispatch(setGates(gates));
  };
}